import React from "react";
import {get} from "lodash";
import {graphql, useStaticQuery, Link} from "gatsby";
import Helmet from "react-helmet";
import Section from "../components/section/section";
import styles from '../scss/page.scss';
import {Accordion as BootstrapAccordion, Card} from "react-bootstrap";
import Img from "gatsby-image/withIEPolyfill";
import Carousel from "react-bootstrap/Carousel";
import ReviewStars from "../components/review-stars/review-stars";
import TrustBox from "../components/trustpilot";
import ToC from "../components/table-of-contents/table-of-contents.js";
import Layout from "../components/layout";
import SEO from "../components/seo";
import {buildBreadcrumbsItem, authorUrl, postUrl} from '../helpers'



class EmotionalSupportDogGuide extends React.Component {
  constructor(props) {
    super(props);
    this.author = {
      name: 'Prairie Conlon',
      title: 'LPC, NCC'
    }
    this.state = { posSticky: 0 };
    this.content =  [
      {
        id: 'what-is-an-emotional-support-animal',
        label: 'What is an Emotional Support Animal (ESA)?',
      },
      {
        id: 'what-is-an-emotional-support-dog',
        label: 'What is an Emotional Support Dog?',
        children : [
          {
            id: 'what-is-an-emotional-support-dog-1',
            label: 'Emotional Support Dog Requirements',
          },
          {
            id: 'what-is-an-emotional-support-dog-2',
            label: 'What’s the Difference Between a Service, Emotional Support, and a Therapy Animal?',
          },
          {
            id: 'what-is-an-emotional-support-dog-3',
            label: 'Pet Vs. Emotional Support Animals: What’s the Difference?',
          }
        ]
      },
      {
        id: 'emotional-support-animal-training',
        label: 'Emotional Support Animal Training',
      },
      {
        id: 'emotional-support-animal-laws',
        label: 'Emotional Support Animal Laws',
      },
      {
        id: 'esa-housing-letter',
        label: 'ESA Housing Letter',
      },
      {
        id: 'esa-travel-letter',
        label: 'ESA Travel Letter',
        children : [
          {
            id: 'esa-travel-letter-1',
            label: 'Emotional Support dog in US Airport',
          }
        ]
      },
      {
        id: '4-common-questions-about-esa-laws',
        label: '4 Common Questions about ESA Laws',
        children : [
          {
            id: '4-common-questions-about-esa-laws-1',
            label: 'What if an Airline or Landlord does not accept my ESA Letter and charges me a pet-related fee?',
          },
          {
            id: '4-common-questions-about-esa-laws-2',
            label: 'Can I bring my emotional support animal in the cabin of a commercial aircraft?',
          },
          {
            id: '4-common-questions-about-esa-laws-3',
            label: 'Can I take my emotional support animal into restaurants or other public places?',
          },
          {
            id: '4-common-questions-about-esa-laws-4',
            label: 'How will my landlord or property manager be able to verify my letter?',
          }
        ]
      },
      {
        id: 'legitimate-esa-registration',
        label: 'Legitimate ESA Registration',
        children : [
          {
            id: 'legitimate-esa-registration-1',
            label: 'Service Dog Registration',
          },
          {
            id: 'legitimate-esa-registration-2',
            label: 'Service Cats: Can a Cat be a Service Animal?',
          }
        ]
      },
      {
        id: '5-ways-an-emotional-support-animal-can-help-you-cope-with-your-symptoms',
        label: '5 Ways an Emotional Support Animal Can Help You Cope with Your Symptoms',
      },
      {
        id: 'why-people-with-mental-illness-find-it-hard-to-ask-a-doctor-for-an-esa',
        label: 'Why People with Mental Illness Find it Hard to Ask a Doctor for an ESA!',
      },
      {
        id: 'our-customers-love-us',
        label: 'Our Customers Love Us',
      },
      {
        id: 'how-to-ask-doctor-for-emotional-support-animal-letter',
        label: 'How to Ask Doctor for Emotional Support Animal Letter',
      },
      {
        id: 'asking-your-therapist-for-an-esa-letter',
        label: 'Asking your Therapist for an ESA Letter',
      },
      {
        id: '5-tips-on-how-to-ask-your-doctor-for-an-esa',
        label: '5 Tips on How to Ask YOUR Doctor for an ESA',
      },
      {
        id: 'want-to-know-if-you-are-eligible-to-become-an-esa-owner',
        label: 'Want to know if you are eligible to become an ESA owner?',
      },
      {
        id: 'therapetic-is-here-to-help-you-get-a-valid-emotional-support-dog-letter',
        label: 'Therapetic is Here to Help You Get a Valid Emotional Support Dog Letter',
        children : [
          {
            id: 'therapetic-is-here-to-help-you-get-a-valid-emotional-support-dog-letter-1',
            label: 'What do the Letters Say: Can You Get an Emotional Support Animal Letter Sample?',
          },
          {
            id: 'therapetic-is-here-to-help-you-get-a-valid-emotional-support-dog-letter-2',
            label: 'How Do I Know That Your Website Is Legitimate And Not A Scam Like So Many Other Websites?',
          },
          {
            id: 'therapetic-is-here-to-help-you-get-a-valid-emotional-support-dog-letter-3',
            label: 'Is CertaPet Legit?',
          }
        ]
      }

    ]
    this.reviews =  [
      {
        content: 'The entire process was very efficient and less time-consuming. My therapist did a great job in assisting me with my case and explaining the details.',
        stars: 5
      },
      {
        content: 'I couldn’t be happier with the customer service. They were very considerate and thorough in their evaluation and timely on getting me the paperwork required. I can’t thank you enough!',
        stars: 5
      },
      {
        content: 'The process was extremely easy, fast and convenient. Once approved I had my letter in a couple of days in my mailbox and same day in my email. I’m soo glad I have my pet as an emotional support animal. Now I don’t have to worry about being separated from him ever!',
        stars: 5
      }

    ]
    this.contentAccordion = [
      [
        {
          id: 'what-is-an-emotional-support-dog-1',
          title: 'Emotional Support Dog Requirements',
          description: 'When it comes to requirements, there aren’t many. If your dog provides you with love and care then they could be your ESA. With that being said, the animal must be beneficial for your health and not put you or anyone else in harm\'s way. Overall, most dogs are recognized as appropriate emotional support animals with the exception of a few outside breeds. In terms of an ESA owner, the key requirement you need is an emotional support animal letter stating the dog is beneficial to your mental/emotional health. This letter can only be written by a licensed mental health professional.'
        },
        {
          id: 'what-is-an-emotional-support-dog-2',
          title: 'What’s the Difference Between a Service, Emotional Support, and a Therapy Animal?',
          description: 'To understand the differences in the laws, get to know the difference in these animals. Emotional support animals, therapy animals, and service animals can assist people with a disability, but there are differences in how they do so. These three laws can help distinguish them: Americans with Disabilities Act (ADA), Air Carrier Access Act (ACAA), and Fair Housing Act (FHA).'
        },
        {
          id: 'what-is-an-emotional-support-dog-3',
          title: 'Pet Vs. Emotional Support Animals: What’s the Difference?',
          description: '“Are emotional support animals allowed in restaurants? What about pets? Is there even a difference between these two?!” These are questions we get a lot. To answer them properly, we need to first learn about what an emotional support dog is and what makes them different from a pet! A pet is a cute companion animal that entertains their owners and keeps them company. Pet owners get them because they love animals and want a new furry buddy in their lives.ESAs have a job to do, however. They have one giant task: making living with a mental health illness or condition easier. They maintain their owner’s well-being and provide comfort during the really bad days. Ufff — not an easy job, sometimes! People suffering from mental or emotional conditions such as post-traumatic stress disorder (PTSD, anxiety or depression may massively benefit from the companionship of an ESA.'
        }
      ],
      [
        {
          id: 'esa-travel-letter-1',
          title: 'Emotional Support Dog Requirements',
          description: 'When it comes to requirements, there aren’t many. If your dog provides you with love and care then they could be your ESA. With that being said, the animal must be beneficial for your health and not put you or anyone else in harm\'s way.Overall, most dogs are recognized as appropriate emotional support animals with the exception of a few outside breeds. In terms of an ESA owner, the key requirement you need is an emotional support animal letter stating the dog is beneficial to your mental/emotional health. This letter can only be written by a licensed mental health professional.'
        }
      ],
      [
        {
          id: '4-common-questions-about-esa-laws-1',
          title: 'What if an Airline or Landlord does not accept my ESA Letter and charges me a pet-related fee?',
          description: 'When a person with a disability believes that he/she has been subjected to a discriminatory housing practice, including a provider’s wrongful denial of a request for reasonable accommodation, he/she may file a complaint with HUD within one year after the alleged denial or may file a lawsuit in federal district court within two years of the alleged denial. If a complaint is filed, HUD will investigate the complaint at no cost to the person with a disability. If their case goes to an administrative hearing, HUD attorneys will litigate the case on their behalf. The respondent can be ordered to: Compensate the person for actual damages, including humiliation, pain and suffering. Provide injunctive or other equitable relief. Pay the Federal Government a civil penalty to vindicate the public interest. The maximum penalties are $16,000 for a first violation and $70,000 for a third violation within seven years. Pay reasonable attorney’s fees and costs. On the other hand, under the Air Carrier Access Act (ACAA), anyone with a diagnosis of a mental disability and an emotional support animal letter from a mental health professional verifying the emotional benefit of the animal will be allowed to travel with the animal. If the requirements are met, the airline is not legally allowed to ask questions about the disability and cannot restrict ESA owners and their animals from boarding the airplane. In order to be covered by the Air Carrier Access Act and comply with airline regulations, there are certain requirements that ESA owners must meet. These requirements include: Explanation of why the animal provides emotional support. Verification letter from a licensed mental health professional prescribing or endorsing the animal as an ESA offering benefits for a particular mental disability. The mental or emotional diagnosis must comply with the current edition of the Diagnostic and Statistical Manual of Mental Disorders (DSM-V).'
        },
        {
          id: '4-common-questions-about-esa-laws-2',
          title: 'Can I bring my emotional support animal in the cabin of a commercial aircraft?',
          description: 'Yes. Be sure to check with your airline before your travel date. Even though the Air Carrier Access Act regulates procedures, airlines may require additional information and may have other restrictions you should know about.'
        },
        {
          id: '4-common-questions-about-esa-laws-3',
          title: 'Can I take my emotional support animal into restaurants or other public places?',
          description: 'It depends. Unlike service animals who can enter public places, ESAs can only go into establishments that have a pet-friendly policy. Other than that, they are mainly intended to be a companion during flights and housing.'
        },
        {
          id: '4-common-questions-about-esa-laws-4',
          title: 'How will my landlord or property manager be able to verify my letter?',
          description: 'A landlord may verify an ESA letter by confirming the therapist’s license number. Since they cannot speak directly to the health care professional because of HIPPA privacy laws, the property manager can request the reasonable accommodation document used by the Department of Housing and Urban Development (HUD) to verify a letter.'
        }
      ],
      [
        {
          id: 'legitimate-esa-registration-1',
          title: 'Service Dog Registration',
          description: 'Like emotional support animal registration, service dog registration is not real. Let us state that there is no official database or registry of service animals. Service dog owners are not required to get or carry any kind of service dog certificate, and businesses are not allowed to ask for one. Similarly, there is no centralized test or certification process for service animals, though the charities or organizations that train service dogs all have their own testing process to see if a dog is ready to become a service dog. Training is required, registering is not.'
        },
        {
          id: 'legitimate-esa-registration-2',
          title: 'Service Cats: Can a Cat be a Service Animal?',
          description: [
            'We often get asked, “Can a cat be a Service Animal?”. The short answer: Cats CANNOT be service animals. ',
            <Link to="/emotional-support-cat">Cats CAN be emotional support animals.</Link>,
            ' According to the American Disability Act (ADA), “Service Animals are defined as dogs that are individually trained to do work or perform tasks for people with disabilities.” There is a special provision written in for miniature horses, but nothing that mentions specifically service cats. However, as mentioned above, cats can certainly qualify as an emotional support animal (with a letter prescribed from a licensed mental health professional), and there is no training and requirements for your furry companion animal.'
          ],
        }
      ],
      [
        {
          id: 'therapetic-is-here-to-help-you-get-a-valid-emotional-support-dog-letter-1',
          title: 'What do the Letters Say: Can You Get an Emotional Support Animal Letter Sample?',
          description: 'At Therapetic, our focus is on helping people to get 100% legal ESA letters. As such, we don’t keep samples of ESA letters on the website, to avoid fake versions being issued.'
        },
        {
          id: 'therapetic-is-here-to-help-you-get-a-valid-emotional-support-dog-letter-2',
          title: 'How do I know that your website is legitimate and not a scam like so many other websites?',
          description: 'The information and documentation we issue is 100% compliant with federal and state laws. Your personalized letter is issued by a real licensed mental health professional in your state. In fact, each letter contains the documentation where the board can be contacted and verified.'
        },
        {
          id: 'therapetic-is-here-to-help-you-get-a-valid-emotional-support-dog-letter-3',
          title: 'Is CertaPet Legit?',
          description: 'Dedicated to connecting qualified individuals to licensed mental health professionals in their state, we work along with CertaPet, the most trusted ESA Letter service Online. CertaPet’s main goal is to spread the knowledge on emotional support animals and help those in need get the care they deserve. An ESA Letter from CertaPet provides: Recognition that you are a patient on a case-by-case basis under a licensed mental health professional’s care for mental or emotional disabilities. Verification that you are significantly limited by an individual disability, such as depression or a similar condition, affecting your mental well-being. Prescription for an emotional support dog (also known as a companion dog), or other support animal, as a necessary reinforcement for your mental health within 48 business hour.'
        }
      ]
    ];
    this.itemsRefs = {}
    this.contentAccordion.map(( items, index ) => {
      this.itemsRefs[index] = {}
      items.map(( item, i ) => {
        this.itemsRefs[index][i] = React.createRef();
      })
    })
    this.breadcrumbs = [
      buildBreadcrumbsItem('Emotional Support Animal', this.props.location.href)
    ]
    this.toggleHeaderClass = this.toggleHeaderClass.bind(this);
    this.goToElement = this.goToElement.bind(this)
    this.seo = {
      children: [
        <script type="application/ld+json" key='structured-data'>{`{"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"What is an Emotional Support Animal (ESA)?","acceptedAnswer":{"@type":"Answer","text":"An emotional support animal is a pet that provides comfort and companionship to someone with a psychological, emotional, and/or mental disability. Think of it as a security blanket with four legs and a tail. And while they're usually either a cat or a dog, they can be other types of animals too. Moreover, they don't require training to become an ESA--every pet is qualified already."}},{"@type":"Question","name":"What is an Emotional Support Dog?","acceptedAnswer":{"@type":"Answer","text":"An emotional support dog is a pet that provides therapeutic benefit(s) to their owner through support and companionship to help alleviate symptoms associated with a mental or emotional disability. Emotional support dogs are the most common type of ESA since dogs help with reducing symptoms of anxiety, depression, and other mental and/or emotional disabilities. Plus, it can't hurt that they're pretty darn cute, too."}},{"@type":"Question","name":"What if an Airline or Landlord does not accept my ESA Letter and charges me a pet-related fee?","acceptedAnswer":{"@type":"Answer","text":"When a person with a disability believes that he/she has been subjected to a discriminatory housing practice, including a provider's wrongful denial of a request for reasonable accommodation, he/she may file a complaint with HUD within one year after the alleged denial or may file a lawsuit in federal district court within two years of the alleged denial. If a complaint is filed, HUD will investigate the complaint at no cost to the person with a disability. If their case goes to an administrative hearing, HUD attorneys will litigate the case on their behalf. The respondent can be ordered to: Compensate the person for actual damages, including humiliation, pain and suffering. Provide injunctive or other equitable relief. Pay the Federal Government a civil penalty to vindicate the public interest. The maximum penalties are $16,000 for a first violation and $70,000 for a third violation within seven years. Pay reasonable attorney's fees and costs. On the other hand, under the Air Carrier Access Act (ACAA), anyone with a diagnosis of a mental disability and an emotional support animal letter from a mental health professional verifying the emotional benefit of the animal will be allowed to travel with the animal. If the requirements are met, the airline is not legally allowed to ask questions about the disability and cannot restrict ESA owners and their animals from boarding the airplane. In order to be covered by the Air Carrier Access Act and comply with airline regulations, there are certain requirements that ESA owners must meet. These requirements include: Explanation of why the animal provides emotional support. Verification letter from a licensed mental health professional prescribing or endorsing the animal as an ESA offering benefits for a particular mental disability. The mental or emotional diagnosis must comply with the current edition of the Diagnostic and Statistical Manual of Mental Disorders (DSM-V)."}},{"@type":"Question","name":"Can I bring my emotional support animal in the cabin of a commercial aircraft?","acceptedAnswer":{"@type":"Answer","text":"Yes. Be sure to check with your airline before your travel date. Even though the Air Carrier Access Act regulates procedures, airlines may require additional information and may have other restrictions you should know about."}},{"@type":"Question","name":"Can I take my emotional support animal into restaurants or other public places?","acceptedAnswer":{"@type":"Answer","text":"It depends. Unlike service animals who can enter public places, ESAs can only go into establishments that have a pet-friendly policy. Other than that, they are mainly intended to be a companion during flights and housing."}},{"@type":"Question","name":"How will my landlord or property manager be able to verify my letter?","acceptedAnswer":{"@type":"Answer","text":"A landlord may verify an ESA letter by confirming the therapist's license number. Since they cannot speak directly to the health care professional because of HIPPA privacy laws, the property manager can request the reasonable accommodation document used by the Department of Housing and Urban Development (HUD) to verify a letter."}},{"@type":"Question","name":"How do I know that your website is legitimate and not a scam like so many other websites?","acceptedAnswer":{"@type":"Answer","text":"The information and documentation we issue is 100% compliant with federal and state laws. Your personalized letter is issued by a real licensed mental health professional in your state. In fact, each letter contains the documentation where the board can be contacted and verified."}}]}`}</script>
      ],
      title: 'Legitimate Emotional Support Animal Letter',
      description:  'How to get an ESA Letter that works! Plus everything you need to know about emotional support animal laws, requirements, and registration scams.',
      seoTitle: 'Legitimate Emotional Support Animal Letter'
    }
    this.post = {
      slug: 'emotional-support-animal',
    }
  }
  componentDidMount() {
    const targetElementSticky = document.getElementById('sticky-bar')
    const stickyHeight = targetElementSticky.getBoundingClientRect().height
    this.setState(() => {
      return { posSticky: stickyHeight };
    });
  }

  toggleHeaderClass(index, i) {
    if (this.itemsRefs) {
      for (let f in this.itemsRefs) {
        for (let x in this.itemsRefs[f]) {
          if ((index == f && x == i) || this.itemsRefs[f][x].current.classList.contains('open')) {
            this.itemsRefs[f][x].current.classList.toggle('open')
          }
        }
      }
    }
  }
  /**
   * Smoothly scrolls down to element in page
   * @param  {Event} e
   * @return {void}
   */
  goToElement(e) {
    const { currentTarget } = e
    const id = (currentTarget.getAttribute('href') || '').replace('#', '')
    const targetElement = document.getElementById(id)
    if (targetElement) {
      e.preventDefault()
      const pos = targetElement.getBoundingClientRect()
      const targetTop = pos.top + window.scrollY - this.state.posSticky
      window.scroll({top: targetTop, left: 0, behavior: 'smooth' });
    }
  }

  displayAccordion (n) {
    return (
      <BootstrapAccordion key={`accordion-${n}`} className="mt-5">
        {this.contentAccordion[n].map((item, i) => {
          return (
            <Card key={i}>
              <Card.Header ref={ this.itemsRefs[n][i] }>
                <BootstrapAccordion.Toggle as="h3" id={item.id} eventKey={i} onClick={this.toggleHeaderClass.bind(this, n, i)} className="col-12 col-md-6 mx-auto my-3">
                  <div className="row">
                    <div className="accordion-title col-10 col-md-10">{item.title}</div>
                    <div className="col-2 col-md-2">
                      <p className="icon float-md-right float-left"/>
                    </div>
                  </div>
                </BootstrapAccordion.Toggle>
              </Card.Header>
              <BootstrapAccordion.Collapse eventKey={i}>
                <Card.Body>
                  <div className="col-12 col-md-8 float-right mr-md-5">
                    {item.description}
                  </div>
                </Card.Body>
              </BootstrapAccordion.Collapse>
            </Card>
          )
        })}
      </BootstrapAccordion>
    )
  }

  render() {
    const { data, children } = this.props
    const defaultImage = get(this.props, 'data.defaultImage.childImageSharp.fluid')
    const publisherName = get(this.props, 'data.site.siteMetadata.publisher.name')
    const url = postUrl(this.post, get(this.props, 'data.site.siteMetadata.siteUrl'))
    const ctaUrl = `${get(data, 'site.siteMetadata.certapetInfo.url.ctaUrl')}`

    return (
      <>
        <Layout containerClassNames="page" breadcrumbs={this.breadcrumbs} location={this.props.location}>
          <SEO { ...this.seo } />

          <article className="post-content-container" itemScope itemType="https://schema.org/BlogPosting">
            <meta itemProp="url" content={ url } />
            <link itemProp="mainEntityOfPage" href={ url } />
            <meta itemProp="datePublished" content="2020-12-09T17:51:29" />
            <meta itemProp="dateModified" content="2020-12-10T17:51:10" />
            <meta itemProp="headline" content="Legitimate Emotional Support Animal Letter" />
            { publisherName ? (
              <link itemProp="publisher" href={ `#${publisherName.replace(' ', '')}Org` } />
            ) : ''}
            { this.author ? (
              <div itemProp="author" itemScope itemType="https://schema.org/Person">
                <meta itemProp="name" content={ this.author.name } />
                <meta itemProp="honorificSuffix" content={ this.author.title } />
              </div>
            ) : '' }
            <div className="post-content" itemProp="articleBody">

              <Section className="page-header-section">
                <div className="row">
                  <h1 className='col-12 col-md-8 mt-5 mx-auto mb-3'>
                    Guide to Emotional Support Animals - Everything You Need to Know About ESAs
                  </h1>
                  <div className="blog-data col-12 col-md-8 mt-5 mx-auto text-center">
                    Reviewed by: <a href={authorUrl(this.author)} rel="author" className="blog-author">{this.author.name}, {this.author.title}</a>
                  </div>
                </div>
              </Section>

              <Section bgColor="#e6f5fa" className="icons-header-section">
                <div className="row">
                  <div className="col-12 col-md-6 mx-auto my-n5">
                    <div className="row mx-auto">
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#what-is-an-emotional-support-animal" onClick={this.goToElement}>
                          <Img fluid={data.whatIsAnEsa.childImageSharp.fluid} alt="01-What-is-An-ESA" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p className="mx-sm-1 mx-auto">What Is An ESA</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#what-is-an-emotional-support-dog-1" onClick={this.goToElement}>
                          <Img fluid={data.howToGetOne.childImageSharp.fluid} alt="02-How-To-Get-One" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>How To Get One</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#emotional-support-animal-laws" onClick={this.goToElement}>
                          <Img fluid={data.laws.childImageSharp.fluid} alt="03-Laws" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>Laws</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#esa-housing-letter" onClick={this.goToElement}>
                          <Img fluid={data.esaLetterForHousing.childImageSharp.fluid} alt="04-ESA-Letter-For-Housing" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>ESA Letter For Housing</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#esa-travel-letter" onClick={this.goToElement}>
                          <Img fluid={data.esaLetterForTravel.childImageSharp.fluid} alt="05-ESA-Letter-For-Travel" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>ESA Letter For Travel</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#what-is-an-emotional-support-animal" onClick={this.goToElement}>
                          <Img fluid={data.typesOfAnimals.childImageSharp.fluid} alt="06-Types-of-Animals" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>Types Of Animals</p>
                        </a>
                      </div>
                    </div>
                    <div className="row mx-auto">
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#5-ways-an-emotional-support-animal-can-help-you-cope-with-your-symptoms" onClick={this.goToElement}>
                          <Img fluid={data.howEsasHelp.childImageSharp.fluid} alt="07-How-ESAs-Help" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>How ESA’s Help</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#legitimate-esa-registration" onClick={this.goToElement}>
                          <Img fluid={data.legitimacy.childImageSharp.fluid} alt="08-Legitimacy" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>Legitimacy</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#4-common-questions-about-esa-laws" onClick={this.goToElement}>
                          <Img fluid={data.faqs.childImageSharp.fluid} alt="09-FAQs" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>FAQS</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#our-customers-love-us" onClick={this.goToElement}>
                          <Img fluid={data.therapeticReviews.childImageSharp.fluid} alt="10-Therapetic-Reviews" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>Therapetic Reviews</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href="#how-to-ask-doctor-for-emotional-support-animal-letter" onClick={this.goToElement}>
                          <Img fluid={data.howToAskYourDoctor.childImageSharp.fluid} alt="11-How-To-Ask-Your-Doctor" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>How To Ask Your Doctor</p>
                        </a>
                      </div>
                      <div className="col-6 col-sm-4 col-lg-2 border item text-center py-1 pt-sm-1 px-auto">
                        <a href={`${ctaUrl}&utm_campaign=esapage&utm_content=icon`} target="_blank">
                          <Img fluid={data.freeScreeningTest.childImageSharp.fluid} alt="12-Free-Screening-Test" className="mx-sm-1 mx-5 img-fluid lazyload" />
                          <p>Free Screening Test</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </Section>

              <Section bgColor="#e0f0f0" className="table-of-content py-5">
                <div className="row">
                  <div className='col-12 col-md-6 mt-5 mx-auto my-md-5'>
                    <ToC content={this.content}/>
                  </div>
                </div>
              </Section>

              <Section bgColor="#fbfbfb" className="content-accordion pt-5 px-0">
                <div className="row">
                  <div className='col-10 col-md-6 mt-5 mx-auto my-md-5'>
                    <h2 id="what-is-an-emotional-support-animal">What is an Emotional Support Animal (ESA)?</h2>
                    <br/>
                    <p>An emotional support animal is a pet that provides comfort and companionship to someone with a psychological, emotional, and/or mental disability. Think of it as a security blanket with four legs and a tail.  And while they’re usually either a <Link to="/emotional-support-cat">cat</Link> or a dog, they can be other types of animals too. Moreover, they don't require training to become an ESA--every pet is qualified already.</p>
                    <br/>
                    <br/>
                    <h2 id="what-is-an-emotional-support-dog">What is an Emotional Support Dog?</h2>
                    <br/>
                    <p>An emotional support dog is a pet that provides therapeutic benefit(s) to their owner through support and companionship to help alleviate symptoms associated with a mental or emotional disability.</p>
                    <br/>
                    <p>Emotional support dogs are the most common type of ESA since dogs help with reducing symptoms of anxiety, depression, and other mental and/or emotional disabilities. Plus, it can’t hurt that they’re pretty darn cute, too.</p>
                  </div>
                </div>
                {this.displayAccordion(0)}
              </Section>

              <Section bgColor="#fff" className="background-img-content training px-0">
                <div className="header-section">
                  <div className="container">
                    <div className="row">
                      <div className="col-10 offset-1 title"><h1 id="emotional-support-animal-training" className="mt-4 mt-md-3">Emotional Support Animal Training</h1></div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-10 col-md-6 mx-auto mt-5 mb-5">
                    <p>Unlike service animals, HUD does not require any special training for ESAs. However, we strongly encourage you to make sure your pet understands basic commands, behaves well in a public setting and is trained for traveling if you chose to take it on a flight. The more prepared they are, the less stressful it is for you.</p>
                    <br/>

                    <p>Airlines will revoke the privilege to travel with your ESA if your pet has shown aggression to flight staff, yourself or other passengers on a previous occasion.</p>
                    <br/>

                    <p>And landlord’s can deny the accommodation or ultimately file for an eviction if the emotional assistance animal is particularly disruptive, or the tenant fails to take proper measures to ensure that the animal does not bother other tenants.</p>
                    <br/>
                    <p>Both you and your furry friend are going to have a much easier time of it if your best friend is well socialized and well-behaved in public. This way, you can enjoy the privileges of being able to take your ESA with you wherever you go.</p>
                  </div>
                </div>
              </Section>

              <Section bgColor="#eaf5fa" className="image-text-alternate px-0">
                <div className="row align-items-center">
                  <div className="col-12 col-md-6">
                    <Img fluid={data.womanPlayingWithHerEmotionalSupportDogInTheLivingRoom.childImageSharp.fluid} alt="Woman Playing With Her Emotional Support Dog In The Living Room" className="img-fluid lazyload" />
                  </div>
                  <div className="col-12 col-md-6 mb-5">
                    <div className="container">
                      <h2 id="emotional-support-animal-laws" className="col-12 col-md-12 mb-5 mt-5">Emotional Support Animal Laws</h2>
                    </div>
                    <div className="container">
                      <div className="col-12 col-md-10">
                        <p>Owners taking advantage of the emotional support animals laws fair housing act ruins it for everyone else.</p>
                        <br/>
                        <p>It is important that anyone considering an Emotional Support Animal letter be aware of the laws that apply to owners and what they should expect from airlines and landlords.</p>
                        <br/>
                        <p>There are two main federal laws applicable to ESAs and their owners, these include the Air Carrier Access Act and the Fair Housing Act.</p>
                        <br/>
                      </div>
                        <div className="col-12 col-md-12 my-4 text-md-left">
                          <div className="call-button my-lg-5">
                            <a href={`${ctaUrl}&utm_campaign=esapage&utm_content=cta1`} target="_blank">START SCREENING PROCESS</a>
                          </div>
                        </div>

                    </div>
                  </div>
                </div>
              </Section>

              <Section bgcolor="#eaf5fa" className="bgsection px-0">
                <div className="row">
                  <div className="col-10 col-md-6 mx-auto mt-5 mb-md-5">
                    <div className="block pt-5 pb-5">
                      <div className="bgsection-img mb-3">
                        <Img fluid={data.housing.childImageSharp.fluid} alt="Housing" className="img-fluid lazyload" />
                      </div>
                      <h2 id="esa-housing-letter" className="mb-5 mt-5">ESA Housing Letter</h2>
                      <p>If you’re looking to preside with your emotional support animal, you must have the right documentation or you can be denied housing.</p>
                      <br/>
                      <p>Verified ESA owners (owners who have an ESA Housing letter written by a Licensed Mental Health Professional) are allowed by law to live with their ESA free of charge, thanks to the Fair Housing Act.</p>
                      <br/>
                      <p>The Fair Housing Act, commonly known as FHA, requires apartments and housing communities that ordinarily restrict pets to make “reasonable accommodation” for assistance animals.</p>
                      <br/>
                      <p>In order to be protected by FHA law, the ESA owner must have a diagnosed disability and provide documentation, such as your ESA housing letter, to the property owner or housing representative.</p>
                      <br/>
                      <p>With your letter, a landlord has no right to require you to pay extra for your ESA or deny you housing even if it has a no pets allowed-policy. They also cannot question the disability or require the animal to wear identification as an Emotional Support Animal.</p>
                      <br/>
                      <p>They can, however, charge and/or evict you if the animal damages the property or harms others. So again, make sure your pet is trained to behave and respect its surrounding environment.</p>
                    </div>
                    <div className="block pt-5 pb-5">
                      <div className="bgsection-img mb-3">
                        <Img fluid={data.travel.childImageSharp.fluid} alt="Travel" className="img-fluid lazyload" />
                      </div>
                      <h2 id="esa-travel-letter" className="mb-5 mt-5">ESA Travel Letter</h2>
                      <p>Thanks to the Air Carrier Access Act, you can fly hassle-free with your animal — and without charge — so long as you qualify and have obtained an emotional support animal travel letter from a licensed mental health professional.</p>
                      <br/>
                      <p>Your ESA travel letter will need to be written by a licensed mental health professional in your state and will explain that your animal is a part of your treatment plan and needs to accompany you to provide relief from your symptoms.</p>
                    </div>
                  </div>
                </div>
                {this.displayAccordion(1)}
                <div className="row pb-4 pt-4">
                    <div className="col-10 col-md-6 mt-5 mb-5 mx-auto text-center text-md-left">
                      <div className="call-button">
                        <a href={`${ctaUrl}&utm_campaign=esapage&utm_content=cta2`} target="_blank">START SCREENING PROCESS</a>
                      </div>
                    </div>
                  </div>

              </Section>

              <Section bgColor="#fff" className="background-img-content questions px-0">
                <div className="header-section">
                  <div className="container">
                    <div className="row">
                      <div className="col-10 offset-1 title"><h1 id="4-common-questions-about-esa-laws" className="mt-3">4 Common Questions about ESA Laws</h1></div>
                    </div>
                  </div>
                </div>
                {this.displayAccordion(2)}
              </Section>

              <Section bgColor="#e5f5fa" className="customize bgaccordion py-0 px-0">
                <div className="row">
                  <div className="col-12 col-md-6 mx-auto">
                    <Img fluid={data.womanShowsTherapeticSiteToHerEmotionalSupportDog.childImageSharp.fluid} alt="Woman Shows Therapetic Site To Her Emotional Support Dog" className="img-fluid lazyload" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-10 col-md-6 mx-auto mt-5 mb-5">
                    <h2 id="legitimate-esa-registration">Legitimate ESA Registration</h2>
                    <br/>
                    <p>To be clear, emotional support animal registration or emotional support animal certification is not real. You do not need to register your ESA in any database to be a legal emotional support animal owner.</p>
                    <br/>
                    <p>What you need to be a legal ESA owner is simple - an ESA letter provided by your licensed mental health professional.</p>
                    <br/>
                    <p>The letter should include:</p>
                    <br/>
                    <dl>
                      <li key="item-1">The type of license carried by your licensed mental health professional</li>
                      <li key="item-2">The license numbers</li>
                      <li key="item-3">The issue date of the license</li>
                      <li key="item-4">The state in which the license was issued</li>
                      <li key="item-5">The date on which the letter was written</li>
                      <li key="item-6">The ESA letter should confirm the following information:</li>
                      <li key="item-7">That you are currently a patient of this LMHP</li>
                      <li key="item-8">You are being treated for a disability</li>
                      <li key="item-9">That you are significantly inhibited in performing a major life activity</li>
                      <li key="item-10">That the prescription of an ESA is an integral part of your treatment plan</li>
                    </dl>
                  </div>
                </div>
                {this.displayAccordion(3)}
              </Section>

              <Section bgColor="#e8f4f4" className="section-cards py-0 px-0">
                <div className="row">
                  <div className="col-10 col-md-10 text-center mt-5 mx-auto">
                    <h2 id="5-ways-an-emotional-support-animal-can-help-you-cope-with-your-symptoms">5 Ways an Emotional Support Animal Can Help<br className='d-none d-md-block'/> You Cope with Your Symptoms</h2>
                    <br/>
                    <p>Emotional support animals can help their owners in numerous ways.</p>
                    <p>A few are listed here:</p>
                    <br/>
                    <div className="row mt-5 pb-5">
                      <div className="col-12 col-md-4 text-center mb-5 mb-md-auto">
                        <Card>
                          <Card.Header className="rounded-circle number">
                            1
                          </Card.Header>
                          <Card.Body>
                            <Card.Title as="h3" className="mb-4 mt-3">Acting as a distraction from intrusive or negative thoughts</Card.Title>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="col-12 col-md-4 text-center mb-5 mt-5 mb-md-auto mt-md-auto">
                        <Card>
                          <Card.Header className="rounded-circle number">
                            2
                          </Card.Header>
                          <Card.Body>
                            <Card.Title as="h3" className="mb-4 mt-3">Establishing a healthy routine of regular exercise, play, and responsibility</Card.Title>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="col-12 col-md-4 text-center mb-5 mt-5 mb-md-auto mt-md-auto">
                        <Card>
                          <Card.Header className="rounded-circle number">
                            3
                          </Card.Header>
                          <Card.Body>
                            <Card.Title as="h3" className="mb-4 mt-3">Gaining confidence to go outside and create opportunities for socialization</Card.Title>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                    <div className="row mt-md-5 mt-4 mb-5">
                      <div className="col-12 col-md-4 offset-md-2 text-center mb-5 mb-md-auto">
                        <Card>
                          <Card.Header className="rounded-circle number">
                            4
                          </Card.Header>
                          <Card.Body>
                            <Card.Title as="h3" className="mb-4 mt-3">Providing unconditional love and support in times of stress or unhappiness</Card.Title>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="col-12 col-md-4 text-center mb-5 mt-5 mb-md-auto mt-md-auto">
                        <Card>
                          <Card.Header className="rounded-circle number">
                            5
                          </Card.Header>
                          <Card.Body>
                            <Card.Title as="h3" className="mb-4 mt-3">Being a calming presence that helps to block stress hormones and encourages the release of endorphins</Card.Title>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                  </div>
                  <div className="col-10 col-md-12 text-center mx-auto mb-5 mt-md-0 d-block d-md-none">
                    <div className="call-button my-lg-5">
                      <a href={`${ctaUrl}&utm_campaign=esapage&utm_content=cta3`} target="_blank">START SCREENING PROCESS</a>
                    </div>
                  </div>

                </div>
              </Section>

              <Section bgColor="#fff" className="image-text-alternate px-0">
                <div className="row align-items-center">
                  <div className="col-12 col-md-6">
                    <Img fluid={data.womanRestingWhileHerEsaKissesHer.childImageSharp.fluid} alt="Woman Playing With Her Emotional Support Dog In The Living Room" className="img-fluid lazyload" />
                  </div>
                  <div className="col-12 col-md-6 mb-5">
                    <div className="container">
                      <h2 id="why-people-with-mental-illness-find-it-hard-to-ask-a-doctor-for-an-esa" className="col-12 col-md-12 mb-5 mt-5">Why People with Mental Illness <br className='d-none d-md-block'/>Find it Hard to Ask a Doctor for an ESA</h2>
                    </div>
                    <div className="container">
                      <div className="col-12 col-md-10">
                        <p>Unfortunately, mental illness still remains a taboo subject for some, and many people find it difficult to address the topic with their doctor. Here at Therapetic, we’re all about breaking the stigma around mental health problems. Talking to your doctor about depression or anxiety should be no different than talking to them about the flu or a stomach ache. So be sure to seek out a therapeutic option, or otherwise you’re ignoring your essential needs for wellness. </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Section>

              <Section bgColor="#e0f0f0" className="review">
                <div className="row">
                  <div className="col-12 col-md-10 text-center mt-5 mx-auto">
                    <h2 id="our-customers-love-us">Our Customers Love Us</h2>
                    <br/>
                    <p>We pride ourselves on providing support throughout the process.</p>
                    <p>Which is why we’re #1 in the ESA Letter category.</p>
                    <br/>
                    <div className="row">
                      <div className="col-12 col-md-12 mt-5 mx-auto">
                        <Carousel className="carousel-reviews text-left d-block d-md-none" controls={false}>
                          { this.reviews.map((review, index) => {
                            return (
                              <Carousel.Item className="reviews-slide" key={index}>
                                <div className="row">
                                  <div className="col-12 col-md-4 text-center mt-3">
                                    <Card>
                                      <Card.Header>
                                        <Img fluid={data.blockquote.childImageSharp.fluid} alt="Review Icon" className="img-fluid lazyload" />
                                      </Card.Header>
                                      <Card.Body>
                                        <Card.Text>
                                          {review.content}
                                        </Card.Text>
                                        <ReviewStars stars={review.stars} color="#2dbecc" />
                                      </Card.Body>
                                    </Card>
                                  </div>
                                </div>
                              </Carousel.Item>
                            )
                          })}
                        </Carousel>

                        <Carousel className="carousel-reviews text-left d-none d-sm-none d-md-block" controls={false}>
                          <Carousel.Item className="reviews-slide">
                            <div className="row">
                              { this.reviews.map((review, index) => {
                                return (
                                  <div className="col-12 col-md-4 text-center mt-3" key={index}>
                                    <Card>
                                      <Card.Header>
                                        <Img fluid={data.blockquote.childImageSharp.fluid} alt="Review Icon" className="img-fluid lazyload" />
                                      </Card.Header>
                                      <Card.Body>
                                        <Card.Text>
                                          {review.content}
                                        </Card.Text>
                                        <ReviewStars stars={review.stars} color="#2dbecc" />
                                      </Card.Body>
                                    </Card>
                                  </div>
                                )
                              })}
                            </div>
                          </Carousel.Item>
                        </Carousel>
                      </div>

                      <div className="container">
                        <div className="row pt-5 mt-5 pb-5">
                          <a href="https://www.trustpilot.com/review/therapetic.org?utm_medium=trustbox&utm_source=MicroReviewCount" target="_blank" className="my-4 mx-auto btn-cta text-center">READ ALL REVIEWS</a>
                          <div className="col-12 pb-5">
                            <TrustBox templateId="5419b6a8b0d04a076446a9ad" businessUnitId="5a0093cb0000ff0005afb51b" theme="light" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Section>

              <Section bgColor="#e5f5fa" className="customize py-0 px-0">
                <div className="row">
                  <div className="col-12 col-md-6 mx-auto mt-md-5">
                    <Img fluid={data.womanHuggingHerEmotionalSupportCat.childImageSharp.fluid} alt="Woman Hugging Her Emotional Support Cat" className="img-fluid lazyload mt-md-5" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-10 col-md-6 mx-auto mt-5 mb-5">
                    <h2 id="how-to-ask-doctor-for-emotional-support-animal-letter">How to Ask Doctor for Emotional Support <br className='d-none d-md-block'/> Animal Letter</h2>
                    <br/>
                    <p>If you’re receiving treatment from a licensed mental health professional for a diagnosed mental illness or emotional disability, you can ask them to write you an ESA letter. This is a simple process, but it could make a real difference.</p>
                    <br/>
                    <p>With a valid ESA letter, you and your emotional support animal are eligible for legal protections, such as being able to travel with your ESA in the cabin free of charge on commercial flights and living with your ESA in rented accommodation.</p>
                    <br/>
                    <p>An ESA letter should be written on the official letterhead of your doctor or therapist, and state that you have been diagnosed with a mental illness for which you are receiving treatment. It should indicate that your emotional support animal is a part of your treatment plan and necessary for you to carry out daily tasks. It should also contain details of your doctor or therapist’s license to practice in the state you are located in.</p>

                    <br/>
                    <br/>
                    <br/>
                    <h2 id="asking-your-therapist-for-an-esa-letter">Asking your Therapist for an ESA Letter</h2>
                    <br/>
                    <p>If your therapist is a licensed mental health professional, they can also issue an ESA letter. The same rules apply: it must be on letterhead paper, must state that you have been diagnosed with a mental or emotional disability and are receiving treatment for it from the letter’s issuer and that ESA is a part of that treatment. It must also contain the issuer’s license number and the date and place where the license was issued.</p>
                  </div>
                </div>
              </Section>

              <Section bgColor="#f0f9fc" className="cards-left-number">
                <div className="row">
                  <div className="col-12 col-md-6 text-center mt-5 mx-auto">
                    <h2 id="5-tips-on-how-to-ask-your-doctor-for-an-esa">5 Tips on How to Ask YOUR Doctor for<br className='d-none d-md-block'/> an ESA</h2>
                    <br/>
                    <p>Follow these five tips on how to ask doctor for an emotional support animal letter.</p>
                    <br/>

                    <div className="item row mt-5">
                      <div className="col-12 col-md-12">
                        <div className="row px-md-5 px-3 py-5">
                          <div className="col-2 col-md-2 rounded-circle">1</div>
                          <div className="col-10 col-md-10 text-left">
                            <p>The first thing you should do before even considering a conversation with your doctor about an ESA letter is to make sure you’ve read up about what emotional support animals are and how they can help. Think about how one would fit into your life.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="item row mt-5">
                      <div className="col-12 col-md-12">
                        <div className="row px-md-5 px-3 py-5">
                          <div className="col-2 col-md-2 rounded-circle">2</div>
                          <div className="col-10 col-md-10 text-left">
                            <p>Keep a record of your symptoms to show your doctor. Some people use a mobile app for this, while others prefer to go old school with a diary on paper. Knowing how you felt and when you felt that way will help you to see patterns of the things that have helped you to cope better—like being around animals.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="item row mt-5">
                      <div className="col-12 col-md-12">
                        <div className="row px-md-5 px-3 py-5">
                          <div className="col-2 col-md-2 rounded-circle">3</div>
                          <div className="col-10 col-md-10 text-left">
                            <p>If you already have a pet, think about the ways that it helps you to feel better, and make sure you share these reasons with your doctor.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="item row mt-5">
                      <div className="col-12 col-md-12">
                        <div className="row px-md-5 px-3 py-5">
                          <div className="col-2 col-md-2 rounded-circle">4</div>
                          <div className="col-10 col-md-10 text-left">
                            <p>Be calm and confident when you ask your doctor to prescribe you an emotional support animal. Outline how you think it will help, and what exactly you need the doctor to do to help make this happen.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="item row mt-5">
                      <div className="col-12 col-md-12">
                        <div className="row px-md-5 px-3 py-5">
                          <div className="col-2 col-md-2 rounded-circle">5</div>
                          <div className="col-10 col-md-10 text-left">
                            <p>If you don’t feel comfortable asking your doctor for an ESA letter, Therapetic is here to help. Therapetic can help to connect you with a licensed mental health professional in your state, meaning that you can get an ESA letter quickly and in a stress-free way.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <br/>
                    <br/>

                    <h2 id="want-to-know-if-you-are-eligible-to-become-an-esa-owner">Want to know if you are eligible to become <br className='d-none d-md-block'/>an ESA owner? </h2>
                    <br/>
                    <br/>
                    <p>A quick screening will get you started! TheraPetic, powered by CertaPet, can help you throughout the entire process thanks to our fully qualified Licensed Mental Health Professionals.</p>
                    <br/>
                  </div>
                  <div className="col-12 col-md-12 mt-3 text-center mb-5">
                    <div className="call-button my-lg-5">
                      <a href={`${ctaUrl}&utm_campaign=esapage&utm_content=cta4`} target="_blank">START SCREENING PROCESS</a>
                    </div>
                  </div>
                </div>
              </Section>

              <Section bgColor="#fff" className="customize py-0 px-0">
                <div className="row">
                  <div className="col-12 col-md-6 mx-auto mt-md-5">
                    <Img fluid={data.coupleSittingInTheSofaWhileShePlaysWithHerEmotionalSupportDog.childImageSharp.fluid} alt="Couple Sitting In The Sofa While She Plays With Her Emotional Support Dog" className="img-fluid lazyload" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-10 col-md-6 mx-auto mt-5 mb-5">
                    <h2 id="therapetic-is-here-to-help-you-get-a-valid-emotional-support-dog-letter">Therapetic is Here to Help You Get a Valid Emotional Support Dog Letter</h2>
                    <br/>
                    <p>If you’re not currently seeing a doctor or a licensed mental health professional, we're here to facilitate that relationship, and the good news is that it’s very simple!</p>
                    <br/>
                    <p>The first step is to try our free and completely confidential 5-minute screening process. This is designed to see if you may be a good candidate for an ESA. If you are a good candidate for an ESA, Therapetic will connect you with a licensed mental health professional in your state.
                    </p>
                  </div>
                </div>
                {this.displayAccordion(4)}
              </Section>

            </div>
            <meta itemProp="image" content={ defaultImage.src } />
          </article>
        </Layout>
      </>
    )
  }

}

export default (props) => {
  const data = useStaticQuery(graphql`
    query EmotionalSupportDogGuide {
      site {
        siteMetadata {
          certapetInfo {
            url {
              ctaUrl
            }
          }
          siteUrl
          publisher {
            name
          }
        }
      }
      blockquote: file(relativePath: { eq: "page_layout/icons/ico-blockquotes.png" }) {
        childImageSharp {
          fluid(maxWidth: 70, maxHeight: 70) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      whatIsAnEsa: file(relativePath: { eq: "page-icon/ico-01-What-is-An-ESA.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      howToGetOne: file(relativePath: { eq: "page-icon/ico-02-How-To-Get-One.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      }  
      laws: file(relativePath: { eq: "page-icon/ico-03-Laws.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      }  
      esaLetterForHousing: file(relativePath: { eq: "page-icon/ico-04-ESA-Letter-For-Housing.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      }  
      esaLetterForTravel: file(relativePath: { eq: "page-icon/ico-05-ESA-Letter-For-Travel.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      }  
      typesOfAnimals: file(relativePath: { eq: "page-icon/ico-06-Types-of-Animals.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      
      howEsasHelp: file(relativePath: { eq: "page-icon/ico-07-How-ESAs-Help.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      legitimacy: file(relativePath: { eq: "page-icon/ico-08-Legitimacy.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      faqs: file(relativePath: { eq: "page-icon/ico-09-FAQs.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      
      therapeticReviews: file(relativePath: { eq: "page-icon/ico-10-Therapetic-Reviews.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      }  
      howToAskYourDoctor: file(relativePath: { eq: "page-icon/ico-11-How-To-Ask-Your-Doctor.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      }  
      freeScreeningTest: file(relativePath: { eq: "page-icon/ico-12-Free-Screening-Test.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 84, maxHeight: 84) {
            ...GatsbyImageSharpFluid
          }
        }
      }  
      womanPlayingWithHerEmotionalSupportDogInTheLivingRoom: file(relativePath: { eq: "woman-playing-with-her-emotional-support-dog-in-the-living-room.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 778, maxHeight: 654) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      womanShowsTherapeticSiteToHerEmotionalSupportDog: file(relativePath: { eq: "woman-shows-therapetic-site-to-her-emotional-support-dog.jpg" }) {
        childImageSharp { 
          fluid(maxWidth: 778, maxHeight: 654) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      coupleSittingInTheSofaWhileShePlaysWithHerEmotionalSupportDog: file(relativePath: { eq: "couple-sitting-in-the-sofa-while-she-plays-with-her-emotional-support-dog.jpg" }) {
        childImageSharp { 
          fluid(maxWidth: 778, maxHeight: 654) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      womanRestingWhileHerEsaKissesHer: file(relativePath: { eq: "woman-resting-while-her-esa-kisses-her.jpg" }) {
        childImageSharp { 
          fluid(maxWidth: 682, maxHeight: 622) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      womanHuggingHerEmotionalSupportCat: file(relativePath: { eq: "woman-hugging-her-emotional-support-cat.jpg" }) {
        childImageSharp { 
          fluid(maxWidth: 778, maxHeight: 654) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      housing: file(relativePath: { eq: "page_layout/icons/housing-icon.png" }) {
        childImageSharp {
          fluid(maxWidth: 161, maxHeight: 154) {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      travel: file(relativePath: { eq: "page_layout/icons/travel-icon.png" }) {
        childImageSharp {
          fluid(maxWidth: 161, maxHeight: 154) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      defaultImage: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <EmotionalSupportDogGuide  {...props} data={data}/>
  )
};
